import * as actionTypes from 'store/actions/actionTypes'

export const updateCurrentUser = userObject => {
  return {
    type: actionTypes.UPDATE_CURRENT_USER,
    userObject
  }
}
